import Vue from 'vue';
import MaskedInput from 'vue-text-mask';

Vue.component('MaskedInput', MaskedInput);

export default MaskedInput;
